import React, { useState, useContext, useEffect } from 'react';
import ModuleHeaderLayout from '../../components/Common/Layouts/ModuleHeaderLayout';
import { GlobalContext } from '../../providers/GlobalProvider';
import Cyber from '../../components/Screening/mainTabComponents/Cyber';
import FullRecord from './FullRecord';
import { Modal } from '@mui/material';
import RequiredLicense from 'pages/assign/RequiredLicense';
import { LicenseType } from 'pages/assign/LicenseBadge';

const AlertsScreening: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const [showFullRecord, setShowFullRecord] = useState({
    show: false,
    record: {},
  });

  // stripe
  const requiredTiers = ['pro', 'business', 'enterprise'];
  const [userHasCyberSearch, setUserHasCyberSearch] = useState(
    cur_user?.bite_super_admin === true ||
      requiredTiers.includes(cur_user?.license),
  );

  const normalizedLicense = (
    ['none', 'standard', 'pro', 'business', 'enterprise'].includes(
      cur_user?.license,
    )
      ? cur_user.license
      : 'none'
  ) as LicenseType;

  // inputs
  const [cyberInputs, setCyberInputs] = useState<any>({
    cyber: '',
  });
  const [cyberPage, setCyberPage] = useState<number>(0);

  useEffect(() => {
    setUserHasCyberSearch(
      cur_user?.bite_super_admin === true ||
        requiredTiers.includes(cur_user?.license),
    );
  }, [cur_user?.license]);

  useEffect(() => {
    if (props.location.state) {
      const { primary } = props.location.state;
      if (primary) {
        setCyberInputs({
          cyber: primary,
        });
      }
    }
  }, [props.location.state]);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for Cyber and Global Trade Alerts
    </p>
  );

  return (
    <ModuleHeaderLayout
      title='Alerts Screening'
      helpContent={helpContent}
      hubLabel='Data Catalog'
      hubTo='/data/sets'
    >
      <RequiredLicense userLicense={normalizedLicense} minimumLicense='pro' />
      <Cyber
        userHasCyberSearch={userHasCyberSearch}
        setShowFullRecord={setShowFullRecord}
        cur_user={cur_user}
        showFilters={false}
        inputs={cyberInputs}
        setInputs={setCyberInputs}
        page={cyberPage}
        setPage={setCyberPage}
      />
      <Modal
        open={showFullRecord.show}
        onClose={() => setShowFullRecord({ show: false, record: {} })}
      >
        <FullRecord
          setShowFullRecord={setShowFullRecord}
          showFullRecord={showFullRecord}
        />
      </Modal>
    </ModuleHeaderLayout>
  );
};

export default AlertsScreening;
